// src/App.js
import React from 'react';
import '@rainbow-me/rainbowkit/styles.css';
import {
  RainbowKitProvider,
} from '@rainbow-me/rainbowkit';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import Header from './components/Header/Header';
import { config } from './config';
import styled from 'styled-components';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import MainPage from './views/MainPage';
import FinalTable from './views/FinalTable';
import "./App.css";
// import { theme, ConfigProvider } from 'antd';
// import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'

const queryClient = new QueryClient();

const AppContainer = styled.div`
  text-align: center;
`;

const App = () => {

  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider>
              <AppContainer className='bg-primary'>
                <Header />
                <Router>
                  <Switch>
                    <Route exact path="/" render={() => <Redirect to="/claim" />} />
                    {/* <Route exact path="/" component={MainPage} /> */}
                    <Route path="/claim" component={MainPage} />
                    <Route path="/checker" component={FinalTable} />
                  </Switch>
                </Router>
                {/* <ToastContainer
                  theme='dark' /> */}
              </AppContainer>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
};

export default App;
